import { RefObject, useEffect, useRef, useState } from 'react';

export function useCatalogoBusca(contentRef: RefObject<HTMLIonContentElement>, coverRef: RefObject<HTMLDivElement>, categoria: string, setCategoria: (value: string) => void, empresaId: string) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const snapshot = useRef<{ top: number; categoria: string } | null>(null);
  const restoring = useRef(false);
  const generation = useRef(0);
  const previousQuery = useRef('');
  useEffect(() => { setOpen(false); setQuery(''); snapshot.current = null; generation.current++; }, [empresaId]);
  useEffect(() => { if (open) inputRef.current?.focus(); }, [open]);
  useEffect(() => {
    const wasSearching = Boolean(previousQuery.current.trim());
    previousQuery.current = query;
    const version = ++generation.current;
    const frame = requestAnimationFrame(() => {
      if (query.trim()) {
        const header = contentRef.current?.closest('.ion-page')?.querySelector('.catalogo-sticky');
        const offset = (coverRef.current?.offsetHeight || 0) - (header?.getBoundingClientRect().height || 0);
        void contentRef.current?.scrollToPoint(0, Math.max(0, offset), 0);
      } else if (wasSearching && snapshot.current) {
        restoring.current = true;
        setCategoria(snapshot.current.categoria);
        void contentRef.current?.scrollToPoint(0, snapshot.current.top, 0).then(() => {
          if (version === generation.current) restoring.current = false;
        });
      }
    });
    return () => cancelAnimationFrame(frame);
  }, [query, contentRef, coverRef, setCategoria]);
  const start = async () => {
    if (open) { inputRef.current?.focus(); return; }
    const el = await contentRef.current?.getScrollElement();
    snapshot.current = { top: el?.scrollTop || 0, categoria };
    setOpen(true);
  };
  const close = () => { inputRef.current?.blur(); setQuery(''); setOpen(false); };
  return { open, query, setQuery, start, close, inputRef, restoring };
}
